import { gql } from "@apollo/client";

export const GET_ALL_TEMPLES = gql`
  query GetAllTemples {
    getAllTemples {
      temple_id
      temple_name
      address
      is_active
      createdAt
      phone
    }
  }
`;

export const GET_TEMPLE_BY_ID = gql`
  query GetTempleById($temple_id: ID!) {
    getTempleById(temple_id: $temple_id) {
      temple_id
      temple_name
      address
      is_active
      createdAt
      phone
    }
  }
`;


export const GET_TEMPLE_BY_NAME = gql`
  query GetTempleByName($temple_name: String!) {
    getTempleByName(temple_name: $temple_name) {
      temple_id
      temple_name
      address
      is_active
      createdAt
      phone
    }
  }
`;

export const CREATE_TEMPLE = gql`
  mutation CreateTemple($input: createTempleInput) {
    createTemple(input: $input) {
      temple_id
      temple_name
      address
      is_active
      createdAt
      phone
    }
  }
`;

export const UPDATE_TEMPLE = gql`
  mutation UpdateTemple($input: updateTempleInput) {
    updateTemple(input: $input) {
      temple_id
      temple_name
      address
      is_active
      createdAt
      phone
    }
  }
`;


export const DELETE_TEMPLE = gql`
  mutation DeleteTemple($temple_id: ID!) {
    deleteTemple(temple_id: $temple_id)
  }
`;
